import { createFeatureSelector, createReducer, on } from '@ngrx/store';

import { createScopedSelector } from '../../utils/factory.utils';

import { HuntingProductSyncActions } from './hunting-product-sync.actions';

export const HUNTING_PRODUCT_SYNC_STORE_KEY = 'huntingProductSync';

export type SyncCycleState = 'idle' | 'discovering' | 'transferring' | 'succeeded' | 'failed';

export interface HuntingProductSyncState {
  cycleState: SyncCycleState;
  syncedCount: number;
  pendingCount: number;
  lastError: string | undefined;
}

const initialState: HuntingProductSyncState = {
  cycleState: 'idle',
  syncedCount: 0,
  pendingCount: 0,
  lastError: undefined,
};

const selectHuntingProductSyncState = createFeatureSelector<HuntingProductSyncState>(HUNTING_PRODUCT_SYNC_STORE_KEY);
const createHuntingProductSyncSelector = createScopedSelector(selectHuntingProductSyncState);

export const huntingProductSyncReducer = createReducer(
  initialState,

  on(
    HuntingProductSyncActions.syncStarted,
    (state): HuntingProductSyncState => ({
      ...state,
      cycleState: 'discovering',
      syncedCount: 0,
      pendingCount: 0,
      lastError: undefined,
    })
  ),

  on(
    HuntingProductSyncActions.syncDiscoverySucceeded,
    (state, { pendingCount }): HuntingProductSyncState => ({
      ...state,
      cycleState: 'transferring',
      pendingCount,
    })
  ),

  on(
    HuntingProductSyncActions.syncDiscoveryFailed,
    (state, { error }): HuntingProductSyncState => ({
      ...state,
      cycleState: 'failed',
      lastError: error,
    })
  ),

  on(
    HuntingProductSyncActions.mediaItemSynced,
    (state): HuntingProductSyncState => ({
      ...state,
      syncedCount: state.syncedCount + 1,
    })
  ),

  on(
    HuntingProductSyncActions.syncSucceeded,
    (state, { syncedCount }): HuntingProductSyncState => ({
      ...state,
      cycleState: 'succeeded',
      syncedCount,
    })
  ),

  on(
    HuntingProductSyncActions.syncFailed,
    (state, { error }): HuntingProductSyncState => ({
      ...state,
      cycleState: 'failed',
      lastError: error,
    })
  )
);

export const HuntingProductSyncSelectors = {
  getCycleState: createHuntingProductSyncSelector((state: HuntingProductSyncState) => state.cycleState),
  isSyncing: createHuntingProductSyncSelector((state: HuntingProductSyncState) => state.cycleState === 'discovering' || state.cycleState === 'transferring'),
  getSyncedCount: createHuntingProductSyncSelector((state: HuntingProductSyncState) => state.syncedCount),
  getPendingCount: createHuntingProductSyncSelector((state: HuntingProductSyncState) => state.pendingCount),
  getLastError: createHuntingProductSyncSelector((state: HuntingProductSyncState) => state.lastError),
};
